import { displayFlex } from '@onhandtech/onhand-toolkit'
import styled from 'styled-components'

export const NavigationItems = styled.div`
  ${displayFlex({ justifyContent: 'flex-start', gap: '1rem' })}
  flex: 1;
  margin-left: 2rem;
`
